<script setup lang="ts">
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'

const { t } = useI18n()
const dialogRef = inject('dialogRef') as any

const reason = ref('')
const loading = ref(false)

async function confirm() {
  loading.value = true
  try {
    await dialogRef.value?.data?.onConfirm(reason.value || undefined)
    dialogRef.value?.close()
  }
  finally {
    loading.value = false
  }
}

function cancel() {
  dialogRef.value?.close()
}
</script>

<template>
  <div class="p-2 flex flex-col gap-4">
    <p class="text-gray-700">
      {{ dialogRef?.data?.message || t('Are you sure you want to delete this item?') }}
    </p>

    <div class="flex flex-col gap-1">
      <label class="text-sm font-medium text-gray-600">
        {{ t('Reason') }} <span class="text-gray-400">({{ t('optional') }})</span>
      </label>
      <Textarea
        v-model="reason"
        :placeholder="t('Enter a reason for deletion...')"
        rows="3"
        class="w-full"
        auto-resize
      />
    </div>

    <div class="flex justify-end gap-2">
      <Button
        :label="t('Cancel')"
        severity="secondary"
        outlined
        @click="cancel"
      />
      <Button
        :label="t('Delete')"
        severity="danger"
        :loading="loading"
        @click="confirm"
      />
    </div>
  </div>
</template>
